// eslint-disable-next-line import/no-internal-modules
import { t } from '@insided/deprecated-libs/translationsUtils/translations'

export interface Attachment {
  content_id: string
  content_type: string
  context: string
  file_original_name: string
  file_size: number
  file_uuid: string | null
  filename: string
  short_thumb_url: string
  short_url: string
  source: string
  source_thumb: string
  type: string
  url: string
}

export interface ImageAttachment {
  short_url: string
  short_thumb_url: string
  type: string
}

export interface FileAttachment {
  filename?: string
  type: string
  source: string
  source_thumb: string
  file_uuid: string | null
  file_size: number
  file_original_name: string
}

export interface UploadedImage {
  bbcode_url: string
  short_thumb_url: string
  short_url: string
  source: string
  source_thumb: string
  type: string
}

export interface ImageSource {
  source: string
  source_thumb: string
}

export interface SignedFile {
  download_url: string
  filename: string
  url: string
  uuid: string
}

export interface AttachmentError {
  filename: string
  errorPhrase: string
}

const allowedFileTypes = [
  'zip',
  'pdf',
  'xml',
  'txt',
  'csv',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'ppt',
  'pptx',
  'jpg',
  'jpeg',
  'gif',
  'png'
]

export const allowedFilesError = {
  allowed_files_type: allowedFileTypes.join(', '),
  allowed_files_size: '5 Mb'
}

export function normalizeAttachments (attachments: Attachment[]) {
  attachments.forEach((attachment) => {
    if (attachment.file_original_name === '') {
      attachment.file_original_name = attachment.source
      attachment.filename = attachment.source
    }
  })
  return attachments
}

export function checkAttachments (hasFileInProgress: boolean) {
  if (hasFileInProgress) {
    throw {
      response: {
        data: {
          errors: {
            pagetext: t('Common', 'file.upload.in.progress')
          }
        }
      }
    }
  }
}

export function prepareAttachments (attachments: Attachment[]): Array<(ImageAttachment | FileAttachment)> {
  return attachments.map(attachment => {
    if (attachment.type === 'image') {
      return {
        short_url: (attachment.source || '').split('/').pop() ?? '',
        short_thumb_url: (attachment.source_thumb || '').split('/').pop() ?? '',
        type: attachment.type
      }
    }
    return {
      filename: attachment.filename,
      type: attachment.type,
      source: attachment.source,
      source_thumb: attachment.source_thumb,
      file_uuid: attachment.file_uuid,
      file_size: attachment.file_size,
      file_original_name: attachment.file_original_name
    }
  })
}

export function prepareAttachmentsForState (attachments: Attachment[]) {
  return attachments.map(attachment => ({
    ...attachment,
    url: attachment.short_url || attachment.source,
    filename: attachment.file_original_name
  }))
}
